import React from "react";
import useCart from "../../../hooks/useCart";
import { useAuth } from "../../../hooks/useAuth";
import { formatCurrency } from "../../../util/formatters";

const TotalCartTable = ({ showCashbackMessage }) => {
  const { cart, totalValue, orderFinalValue, cashback, setCashback } =
    useCart();

  const cashbackHandler = () => {
    setCashback((prev) => !prev);
  };

  const { userInfo } = useAuth();

  const cartSubtotal = totalValue();

  const availableCashback = userInfo?.cashback_amount ?? 0;

  // Exibe a mensagem apenas quando existe cashback disponível e ele não cobre o valor total.
  // (mantém a mesma regra que estava inline no JSX)
  const shouldShowCashbackOrWarning =
    availableCashback !== 0 && availableCashback;

  const finalOrderValueRaw = orderFinalValue();
  const finalOrderValue = Math.max(0, finalOrderValueRaw);

  const cashbackMessageText = `A Unidade selecionada tem disponível ${formatCurrency(
    availableCashback
  )} de cashback. Para utilizar o valor nesta compra, selecione a caixa ao lado.`;

  const CashbackMessage = () => (
    <div
      className="row"
      style={{
        justifyContent: "center",
        marginBottom: "10px",
      }}
    >
      <div
        id="checkbox"
        className="col-1"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "20px",
        }}
      >
        <input
          checked={cashback}
          type="checkbox"
          style={{ width: "20px" }}
          onChange={cashbackHandler}
        />
      </div>
      <div
        className="col-11"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1px 0px",
        }}
      >
        <label htmlFor="checkbox" style={{ fontSize: "14px" }}>
          {cashbackMessageText}
        </label>
      </div>
    </div>
  );
  const WarningMessage = () => (
    <div
      className="row"
      style={{
        justifyContent: "center",
        marginBottom: "10px",
      }}
    >
      <div
        className="col-1"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: "20px",
        }}
      >
        <i className="fa-solid fa-triangle-exclamation"></i>
      </div>
      <div
        className="col-11"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1px 0px",
        }}
      >
        <label htmlFor="checkbox" style={{ fontSize: "14px" }}>
          Possíveis impostos já estão incluídos no valor apresentado nesta tela. Para mais informações, entrar em contato com o setor administrativo.
        </label>
      </div>
    </div>
  );
  return (
    <>
      {cart.length !== 0 && (
        <div style={{ width: "100%" }}>
          <h3 className="ltn__primary-color">Total do Carrinho</h3>
          {shouldShowCashbackOrWarning &&
            (showCashbackMessage ? <CashbackMessage /> : <WarningMessage />)}
          <table className="table">
            <tbody>
              <tr>
                <td>Subtotal</td>
                <td>{formatCurrency(cartSubtotal)}</td>
              </tr>
              <tr>
                <td>Frete</td>
                <td>
                  {formatCurrency(userInfo?.frete)}
                </td>
              </tr>
              <tr>
                <td>Desconto</td>
                <td style={{
                  color: 'green'
                }}>
                  <strong>
                    -{formatCurrency((userInfo?.discount_percentage * cartSubtotal) / 100)}
                  </strong>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Total</strong>
                </td>
                <td>
                  <strong>{formatCurrency(finalOrderValue)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
          <p className="mt-3">
            Nesta compra você ganhará <strong style={{ color: 'green' }}>
              {formatCurrency((userInfo?.cashback_percentage * cartSubtotal) / 100)}
            </strong> de cashback.
          </p>
        </div>
      )}
    </>
  );
};
export default TotalCartTable;
